// extracted by mini-css-extract-plugin
export default {"pageWrapper":"pageWrapper_pageWrapper__LHnhO","mainMenuPageWrapper":"pageWrapper_mainMenuPageWrapper__q6cUN"};